import { useEffect } from 'react';
import { APP_STORE_URL, PLAY_STORE_URL } from '../storeLinks';

const Downloads = () => {
    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // replace() keeps this page out of history so Back doesn't redirect again.
        // Check if the device is Android
        if (/android/i.test(userAgent)) {
            window.location.replace(PLAY_STORE_URL);
            return;
        }

        // Check if the device is iOS or default case
        window.location.replace(APP_STORE_URL);
    }, []);

    return null;
};

export default Downloads;
